!function(e){var a={init:function(t){var s=e.extend({items:1,itemsOnPage:1,pages:0,displayedPages:5,edges:2,currentPage:1,hrefTextPrefix:"#page-",hrefTextSuffix:"",prevText:"Prev",nextText:"Next",ellipseText:"&hellip;",cssStyle:"light-theme",selectOnClick:!0,onPageClick:function(e,a){},onInit:function(){}},t||{}),i=this;return s.pages=s.pages?s.pages:Math.ceil(s.items/s.itemsOnPage)?Math.ceil(s.items/s.itemsOnPage):1,s.currentPage=s.currentPage-1,s.halfDisplayed=s.displayedPages/2,this.each(function(){i.addClass(s.cssStyle+" simple-pagination").data("pagination",s),a._draw.call(i)}),s.onInit(),this},selectPage:function(e){return a._selectPage.call(this,e-1),this},prevPage:function(){var e=this.data("pagination");return e.currentPage>0&&a._selectPage.call(this,e.currentPage-1),this},nextPage:function(){var e=this.data("pagination");return e.currentPage<e.pages-1&&a._selectPage.call(this,e.currentPage+1),this},getPagesCount:function(){return this.data("pagination").pages},getCurrentPage:function(){return this.data("pagination").currentPage+1},destroy:function(){return this.empty(),this},redraw:function(){return a._draw.call(this),this},disable:function(){var e=this.data("pagination");return e.disabled=!0,this.data("pagination",e),a._draw.call(this),this},enable:function(){var e=this.data("pagination");return e.disabled=!1,this.data("pagination",e),a._draw.call(this),this},updateItems:function(e){var t=this.data("pagination");t.items=e,t.pages=Math.ceil(t.items/t.itemsOnPage)?Math.ceil(t.items/t.itemsOnPage):1,this.data("pagination",t),a._draw.call(this)},_draw:function(){var t,s=this.data("pagination"),i=a._getInterval(s);a.destroy.call(this);var n="UL"===this.prop("tagName")?this:e("<ul></ul>").appendTo(this);if(s.prevText&&a._appendItem.call(this,s.currentPage-1,{text:s.prevText,classes:"prev"}),i.start>0&&s.edges>0){var l=Math.min(s.edges,i.start);for(t=0;t<l;t++)a._appendItem.call(this,t);s.edges<i.start&&i.start-s.edges!=1?n.append('<li class="disabled"><span class="ellipse">'+s.ellipseText+"</span></li>"):i.start-s.edges==1&&a._appendItem.call(this,s.edges)}for(t=i.start;t<i.end;t++)a._appendItem.call(this,t);if(i.end<s.pages&&s.edges>0)for(s.pages-s.edges>i.end&&s.pages-s.edges-i.end!=1?n.append('<li class="disabled"><span class="ellipse">'+s.ellipseText+"</span></li>"):s.pages-s.edges-i.end==1&&a._appendItem.call(this,i.end++),t=Math.max(s.pages-s.edges,i.end);t<s.pages;t++)a._appendItem.call(this,t);s.nextText&&a._appendItem.call(this,s.currentPage+1,{text:s.nextText,classes:"next"})},_getInterval:function(e){return{start:Math.ceil(e.currentPage>e.halfDisplayed?Math.max(Math.min(e.currentPage-e.halfDisplayed,e.pages-e.displayedPages),0):0),end:Math.ceil(e.currentPage>e.halfDisplayed?Math.min(e.currentPage+e.halfDisplayed,e.pages):Math.min(e.displayedPages,e.pages))}},_appendItem:function(t,s){var i,n,l=this,r=l.data("pagination"),p=e("<li></li>"),d=l.find("ul");t=t<0?0:t<r.pages?t:r.pages-1,i=e.extend({text:t+1,classes:""},s||{}),t==r.currentPage||r.disabled?(r.disabled?p.addClass("disabled"):p.addClass("active"),n=e('<span class="current">'+i.text+"</span>")):(n=e('<a href="'+r.hrefTextPrefix+(t+1)+r.hrefTextSuffix+'" class="page-link">'+i.text+"</a>")).click(function(e){return a._selectPage.call(l,t,e)}),i.classes&&n.addClass(i.classes),p.append(n),d.length?d.append(p):l.append(p)},_selectPage:function(e,t){var s=this.data("pagination");return s.currentPage=e,s.selectOnClick&&a._draw.call(this),s.onPageClick(e+1,t)}};e.fn.pagination=function(t){return a[t]&&"_"!=t.charAt(0)?a[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void e.error("Method "+t+" does not exist on jQuery.pagination"):a.init.apply(this,arguments)}}(jQuery);
function randomStockNumber() {
    var randNumWatching = Math.floor(Math.random() * 10) + 1;
    $('.random_stock_number').text(randNumWatching);
}
$(document).ready(function() {
    $(document).on(`click`, `.trigger_product_page_atc`, function(e) {
        $('.product_page_atc').trigger('click');
        // upsellPopupSlider();
    });
   randomStockNumber()
    $("[data-search]").keyup(function() {
        var value = $(this).val().toLowerCase().trim();
        console.log(value)
        $(".js_for_search").filter(function() {

            $(this).toggle($(this).attr('data-filter-que').toLowerCase().indexOf(value) > -1);

        });

    });
    $(".sec-testimonial__content .listcol").slice(3).hide();
    $('#pagination').pagination({
    items: $(".listcol").length,
            prevText: '<svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55078 1.34717L1.38752 9.51043L9.55078 17.6737" stroke="#3F2B18" stroke-width="1.5"></path></svg>',
        nextText: '<svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44922 1.34717L9.61248 9.51043L1.44922 17.6737" stroke="#3F2B18" stroke-width="1.5"></path></svg>',
        // Items allowed on a single page
        itemsOnPage: 3,
        onPageClick: function (noofele) {
        $(".sec-testimonial__content .listcol").hide()
            .slice(3*(noofele-1),
            3+ 3* (noofele - 1)).show();
        }
    });

    $(document).on(`change`, `#single-size`, function(e) {
        let collectionHandle = $('input[name=radio]:checked').attr('data-collection-handle');
        let tagValue = $(this).val();
        let test = `14 x 28,  14 x 30,  15 x 31,  15 x 33,  16 x 32,  17 x 32,  18 x 28,  18 x 32,  18 x 34,  18 x 36,  19 x 30, 19 x 32, 19 x 35,  20 x 30,  20 x 35,  20 x 36, 21 x 33, 21 x 36,  24 x 38,  24 x 42,  25 x 36,  25 x 39,  26 x 36,  26 x 38,  26 x 40,  27 x 36,  27 x 38,  27 x 39,  28 x 40, 16 x 32`;
        $('.product-list .row').html('');
        $('.product-list .row').addClass('test1');
        $('body').addClass('overlay-cus');
        $('#custom-preloader').css('display', 'block');
        $.ajax({
            url: "/collections/" + collectionHandle + "/" + tagValue + "?view=ajax",
            method: "GET",
            dataType: "HTML",
            success: function(htmlData) {
                let html_markup = $(htmlData);
                // let to_replace = $(htmlData).find('.product-list .row').html();
                 let to_replace = $(htmlData).find('.js_bg_product').html();
                $('#custom-preloader').css('display', 'none');
                $('body').removeClass('overlay-cus');
                $('.product-list .row').html(to_replace);
                $(".product-list__col").slice(0, 6).show();
                // $(".product-list .js-load-more-btn").show();
                $('.product-list__desc h5').matchHeight({
                    byRow: 0,
                });
                // if ($(".product-list__col:hidden").length == 0) {
                //     $(".product-list .js-load-more-btn").hide();
                // }
                // $('.test1 .col-lg-4.col-6').addClass('test2');
                // $(".test2").slice(6).hide();
                // $('#pagination1').pagination({
                //     items: $(".test2").length,
                //         prevText: '<svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55078 1.34717L1.38752 9.51043L9.55078 17.6737" stroke="#3F2B18" stroke-width="1.5"></path></svg>',
                //     nextText: '<svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44922 1.34717L9.61248 9.51043L1.44922 17.6737" stroke="#3F2B18" stroke-width="1.5"></path></svg>',
                //     // Items allowed on a single page
                //     itemsOnPage: 6,
                //     onPageClick: function (noofele) {
                //     $(".test2").hide()
                //         .slice(6*(noofele-1),
                //         6+ 6* (noofele - 1)).show();
                //     }
                // });
            },
            error: function(data) {
                window.alert(data.responseJSON.description);
            }
        });

    });
    $(document).on(`change`, `#single-model`, function(e) {
        let collectionHandle = $('input[name=radio]:checked').attr('data-collection-handle');
        let tagValue = $(this).val();
        let test = `14 x 28,  14 x 30,  15 x 31,  15 x 33,  16 x 32,  17 x 32,  18 x 28,  18 x 32,  18 x 34,  18 x 36,  19 x 30, 19 x 32, 19 x 35,  20 x 30,  20 x 35,  20 x 36, 21 x 33, 21 x 36,  24 x 38,  24 x 42,  25 x 36,  25 x 39,  26 x 36,  26 x 38,  26 x 40,  27 x 36,  27 x 38,  27 x 39,  28 x 40, 16 x 32`;
        $('.product-list .row').html('');
        $('.product-list .row').addClass('test1');
        $('body').addClass('overlay-cus');
        $('#custom-preloader').css('display', 'block');
        $.ajax({
            url: "/collections/" + collectionHandle + "/" + tagValue + "?view=ajax",
            method: "GET",
            dataType: "HTML",
            success: function(htmlData) {
                let html_markup = $(htmlData);
                // let to_replace = $(htmlData).find('.product-list .row').html();
                let to_replace = $(htmlData).find('.js_bg_product').html();
                $('#custom-preloader').css('display', 'none');
                $('body').removeClass('overlay-cus');
                $('.product-list .row').html(to_replace);
                $(".product-list__col").slice(0, 6).show();
                // $(".product-list .js-load-more-btn").show();
                $('.product-list__desc h5').matchHeight({
                    byRow: 0,
                });
                // if ($(".product-list__col:hidden").length == 0) {
                //     $(".product-list .js-load-more-btn").hide();
                // }
                // $('.test1 .col-lg-4.col-6').addClass('test2');
                // $(".test2").slice(6).hide();
                // $('#pagination1').pagination({
                //     items: $(".test2").length,
                //         prevText: '<svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55078 1.34717L1.38752 9.51043L9.55078 17.6737" stroke="#3F2B18" stroke-width="1.5"></path></svg>',
                //     nextText: '<svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44922 1.34717L9.61248 9.51043L1.44922 17.6737" stroke="#3F2B18" stroke-width="1.5"></path></svg>',
                //     // Items allowed on a single page
                //     itemsOnPage: 6,
                //     onPageClick: function (noofele) {
                //     $(".test2").hide()
                //         .slice(6*(noofele-1),
                //         6+ 6* (noofele - 1)).show();
                //     }
                // });
            },
            error: function(data) {
                window.alert(data.responseJSON.description);
            }
        });

    });

    $(document).on('change', `.js-cw-product-page-form [data-option-1], .js-cw-product-page-form [data-option-2], .js-cw-product-page-form [data-option-3]`, function(e) {
        randomStockNumber();
        
        let option1 = option2 = option3 = null;
        if ($(`.js-cw-product-page-form [data-option-1]`).length > 0) {
            option1 = $(`.js-cw-product-page-form [data-option-1] select option:selected`).val();
        }
         
        if ($(`.js-cw-product-page-form [data-option-2]`).length > 0) {
            option2 = $(`.js-cw-product-page-form [data-option-2] select option:selected`).val();
        }
        
        if ($(`.js-cw-product-page-form [data-option-3]`).length > 0) {
            option3 = $(`.js-cw-product-page-form [data-option-3] select option:selected`).val();
        }
        let variant_id = null;
        let current_selected_option = null;
        if (option2 == null & option3 == null) {
            current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`);
            variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
        }
        if (option2 != null & option3 == null) {
            current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`);
            variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`).val();
        }
        if (option2 != null & option3 != null) {
            current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`);
            variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
        }
        if (variant_id == null) {
            $(`.product_page_atc`).addClass('soldout');
            $(`.product_page_atc`).text("Unavailable");
            $(`.product_cart_atc`).addClass('soldout');
            // $(`.product_cart_atc`).text("Unavailable");
            $(`.trigger_product_page_atc`).text("Unavailable");
            return true;
        }
        let price = $(current_selected_option).attr('data-price');
        let compare_at_price = $(current_selected_option).attr('data-compareat-price');
        let discount = $(current_selected_option).attr('data-discount');
        let image_src = $(current_selected_option).attr('data-image');
        console.log(image_src);
        let save = $(current_selected_option).attr('data-save');
        let is_available = $(current_selected_option).attr('data-available');
        let variantTitle = $(current_selected_option).text();
        if(variantTitle != "Default Title"){
            $('.variant_title').text(variantTitle);
        }
        $(`.js-cw-product-page-form select.actual-variants`).val(variant_id).trigger('change');
        $(`.js_now_price`).text(price);
        if (compare_at_price > price) {
            $('.js_was_price').html('<del> Was ' + compare_at_price + '</del>');
        } else {
            $('.js_was_price').html('');
        }
        if (compare_at_price > price) {
            $(`.js_discount`).css('display', 'block');
            $(`.js_discount`).html('Save ' + discount);
        } else {
            $(`.js_discount`).css('display', 'none');
        }
        if (is_available == 'true') {
            $(`.product_page_atc`).removeClass('soldout');
            $(`.product_page_atc`).html('<span>Add to Cart</span> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4 12H16.25L11 6.75L11.66 6L18.16 12.5L11.66 19L11 18.25L16.25 13H4V12Z" fill="white"></path> </svg>');
            $(`.trigger_product_page_atc`).html('<span>Add to Cart</span> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4 12H16.25L11 6.75L11.66 6L18.16 12.5L11.66 19L11 18.25L16.25 13H4V12Z" fill="white"></path> </svg>');
            $(`.product_page_atc`).css("pointer-events", "all");
            $(`.trigger_product_page_atc`).css("pointer-events", "all");
            $(`.product_page_atc`).css("opacity", "1");
            $(`.trigger_product_page_atc`).css("opacity", "1");
            $(`.product_cart_atc`).removeClass('soldout');
            $(`.product_cart_atc`).html('<span>Add to Cart</span> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4 12H16.25L11 6.75L11.66 6L18.16 12.5L11.66 19L11 18.25L16.25 13H4V12Z" fill="white"></path> </svg>');
            $(`.product_cart_atc`).css("pointer-events", "all");
            $(`.product_cart_atc`).css("opacity", "1");
        } else {
            $(`.product_page_atc`).addClass('soldout');
            $(`.product_page_atc`).text("Soldout");
            $(`.trigger_product_page_atc`).text("Soldout");
            $(`.product_page_atc`).css("pointer-events", "none");
            $(`.trigger_product_page_atc`).css("pointer-events", "none");
            $(`.product_page_atc`).css("opacity", "0.5");
            $(`.trigger_product_page_atc`).css("opacity", "0.5");
            $(`.product_cart_atc`).addClass('soldout');
            $(`.product_cart_atc`).text("Soldout");
            $(`.product_cart_atc`).css("pointer-events", "none");
            $(`.product_cart_atc`).css("opacity", "0.5");

        }
        let current_position = null;
        cw.variants.forEach((em, ix) => {
            if (em.id == variant_id && em.featured_image != null) {
                current_position = em.featured_image.position - 1;
                $(`.probig`).slick('slickGoTo', current_position);
            }
        });
        // var newurl =
        //     window.location.protocol +
        //     '//' +
        //     window.location.host +
        //     window.location.pathname +
        //     '?variant=' +
        //     variant_id;
        // window.history.replaceState({
        //     path: newurl
        // }, '', newurl);
        /*
        console.log(variant_id);
        console.log(price);
        console.log(compare_at_price);
        console.log(discount);
        console.log(image_src);
        console.log(save);
        */
    });
    

    $(document).on(`click`, `.product_page_atc`, function(e) {
        e.preventDefault();
        let items = Array();
        let form_data_array = $(`.js-cw-product-page-form`).serializeArray();
        let popUpTrue = $(this).attr('data-upsell-popup');
        let item = {};
        form_data_array.forEach((em, ix) => {
            item[em.name] = em.value;
        });
        items.push(item);

        $.ajax({
            url: "/cart/add.js",
            data: {
                items: items
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                if( popUpTrue === 'true'){

                }else{
                window.location = "/cart";
            }
            },
            error: function(data) {
                window.alert(data.responseJSON.description);
            }
        });
    });
    // $(document).on(`click`, `.product_cart_atc`, function(e) {
    //     e.preventDefault();
    //     let items = Array();
    //     let form_data_array = $(`.js-cw-product-page-form`).serializeArray();
    //     let item = {};
    //     form_data_array.forEach((em, ix) => {
    //         item[em.name] = em.value;
    //     });
    //     items.push(item);

    //     $.ajax({
    //         url: "/cart/add.js",
    //         data: {
    //             items: items
    //         },
    //         method: "POST",
    //         dataType: "JSON",
    //         success: function(data) {
    //             window.location = "/cart";

    //         },
    //         error: function(data) {
    //             window.alert(data.responseJSON.description);
    //         }
    //     });
    // });

    $(document).on(`click`, `.upsell_atc`, function(e) {
        e.preventDefault();
        let varId = $(this).attr('data-upsell-id');
        $.ajax({
            url: "/cart/add.js",
            data: {
                id: varId,
                quantity: 1
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                window.location = "/cart";
            },
            error: function(data) {
                window.alert(data.responseJSON.description);
            }
        });
    });


    $(document).on(`click`, `input[name=radio]`, function(e) {
    let collectionHandle = $('input[name=radio]:checked').attr('data-collection-handle');
    let tagValuee = $(this).val();
    $('#step2 .js_collection_image').html('');
    $('body').addClass('overlay-cus');
    $('#custom-preloader').css('display', 'block');
    $.ajax({
        url: "/collections/" + collectionHandle + "/" + tagValuee + '?view=tag-value',
        method: "GET",
        dataType: "HTML",
        success: function(htmlData) {
            $('#custom-preloader').css('display', 'none');
            $('body').removeClass('overlay-cus');
            let html_markup = $(htmlData);
            let to_replace = $(htmlData).find('.js_collection_image').html();
            $('.js_collection_image').html(to_replace);
        },
        error: function(data) {
            window.alert(data.responseJSON.description);
        }
    });

});
 
    // $(document).on(`click`, `input[name=radio]`, function(e) {
    //     $('#single-size')
    //         .find('option')
    //         .remove()
    //         .end()
    //         .append('<option value="whatever">Select Size</option>')
    //         .val('whatever');
    //     $('#single-model')
    //         .find('option')
    //         .remove()
    //         .end()
    //         .append('<option value="whatever">Select Model</option>')
    //         .val('whatever');

    //     function populateDropdownWithModalTags() {
    //         var tags = [];
    //         var sizetags = [];
    //         var sizetagsText = [];
    //         // Loop through each product on the collection page
    //         $(".js_radio_button:checked").each(function() {
    //             var productTags = $(this).data("collection-modal-tag").split(', '); // Assuming data-tags attribute contains the product tags
    //             var productSizeTags = $(this).data("collection-size-tag").split(', '); // Assuming data-tags attribute contains the product tags
    //             var productsizetagsText = $(this).data("collection-size-tag1").split(', '); // Assuming data-tags attribute contains the product tags
    //             $.each(productTags, function(index, tag) {
    //                 if ($.inArray(tag, tags) === -1) {
    //                     tags.push(tag);
    //                 }
    //             });
    //             $.each(productSizeTags, function(index, tag) {
    //                 if ($.inArray(tag, sizetags) === -1) {
    //                     sizetags.push(tag);
    //                 }
    //             });
    //             $.each(productsizetagsText, function(index, tag) {
    //                 if ($.inArray(tag, sizetags) === -1) {
    //                   sizetagsText.push(tag);
    //                 }
    //             });
    //          console.log(sizetagsText.length)
    //          });
    //         // Populate the dropdown with tags
    //         var dropdown1 = $("#single-model");
    //         var dropdown2 = $("#single-size");
    //         $.each(tags, function(index, tag) {
              
    //             if (tag != '') {
    //                 //$('#dropdwon-size').css('display', 'block');
    //                 $('#dropdwon-model').css('display', 'block');
    //                 //$('.size-select').css('display', 'block');
    //                 $('.model-select').css('display', 'block');
    //                 $(".box-desc").removeClass(".box-desc.is-sticky .box-desc");
    //                 let tagmodal = tag;
                  
    //                 let replaceTag = tagmodal.replaceAll("-", " ");
    //                 dropdown1.append($("<option></option>")
    //                     .attr("value", tag)
    //                     .text(replaceTag));
    //             } else {
    //                 //$('#dropdwon-size').css('display', 'none');
    //                 $('#dropdwon-model').css('display', 'none');
    //                 //$('.size-select').css('display', 'none');
    //                 $('.model-select').css('display', 'none');
    //                 $(".box-desc").addClass(".box-desc.is-sticky .box-desc");

    //             }
    //         });
    //         if(sizetagsText.length === 0){
    //           $('#dropdwon-size').css('display', 'none');
    //                 $('.size-select').css('display', 'none');
    //                 $(".box-desc").addClass(".box-desc.is-sticky .box-desc");
    //         }
    //         $.each(sizetagsText, function(index, tag) {
    //             let tagtest = tag;
    //             let con = tagtest.replaceAll("-", " ").toUpperCase();

    //             if (tag != '') {
    //                 $('#dropdwon-size').css('display', 'block');
    //                 $('.size-select').css('display', 'block');
    //                 $(".box-desc").removeClass(".box-desc.is-sticky .box-desc");
    //                 let tagmodal = tag;
    //                 let testtag = tag.replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    //                 let replaceTag = tagmodal.replaceAll("-", " ");
    //                 dropdown2.append($("<option></option>")
    //                 .attr("value", testtag).text(con));
    //             } else {
    //                 $('#dropdwon-size').css('display', 'none');
    //                 $('.size-select').css('display', 'none');
    //                 $(".box-desc").addClass(".box-desc.is-sticky .box-desc");
    //              }
    //         });
          
    //     }
       
    //     // Call the function to populate the dropdown
    //     //populateDropdownWithTags();
    //     populateDropdownWithModalTags();
    //   });
 
     $(document).on(`click`, `input[name=radio]`, function(e) {
            $('#single-size')
                .find('option')
                .remove()
                .end()
                .append('<option value="whatever">Select Size</option>')
                .val('whatever');
            $('#single-model')
                .find('option')
                .remove()
                .end()
                .append('<option value="whatever">Select Model</option>')
                .val('whatever');
    
            function populateDropdownWithModalTags() {
                var tags = [];
                var sizetags = [];
                var sizetagsText = [];
               
                // Loop through each product on the collection page
                $(".js_radio_button:checked").each(function() {
                    var productTags = $(this).data("collection-modal-tag").split(', '); // Assuming data-tags attribute contains the product tags
                    var productSizeTags = $(this).data("collection-size-tag").split(', '); // Assuming data-tags attribute contains the product tags
                    var productsizetagsText = $(this).data("collection-size-tag1").split(', '); // Assuming data-tags attribute contains the product tags
                    $.each(productTags, function(index, tag) {
                        if ($.inArray(tag, tags) === -1) {
                            tags.push(tag);
                        }
                    });
                    $.each(productSizeTags, function(index, tag) {
                        if ($.inArray(tag, sizetags) === -1) {
                            sizetags.push(tag);
                            // console.log("This is tag " + tags);
                            // console.log("This is tagdfdf " + sizetags);
                        }
                    });
                    $.each(productsizetagsText, function(index, tag) {
                        if ($.inArray(tag, sizetags) === -1) {
                          sizetagsText.push(tag);
                         
                        }
                    });
                 });
                // Populate the dropdown with tags
                var dropdown1 = $("#single-model");
                var dropdown2 = $("#single-size");
                $.each(tags, function(index, tag) {
                  
                    if (tag != '') {
                        //$('#dropdwon-size').css('display', 'block');
                        $('#dropdwon-model').css('display', 'block');
                        //$('.size-select').css('display', 'block');
                        $('.model-select').css('display', 'block');
                        $(".box-desc").removeClass("is-sticky-remove");
                        let tagmodal = tag;
                        let replaceTag = tagmodal.replaceAll("-", " ");
                        dropdown1.append($("<option></option>")
                            .attr("value", tag)
                            .text(replaceTag));
                    } else {
                        //$('#dropdwon-size').css('display', 'none');
                        $('#dropdwon-model').css('display', 'none');
                        //$('.size-select').css('display', 'none');
                        $('.model-select').css('display', 'none');
                        $(".box-desc").addClass("is-sticky-remove");
                    }
                });
                 
                 
                if(sizetagsText.length === 0){
                  $('#dropdwon-size').css('display', 'none');
                        $('.size-select').css('display', 'none');
                        $(".box-desc").addClass("is-sticky-remove");
                }
                $.each(sizetagsText, function(index, tag) {
                    let tagtest = tag;
                    let con = tagtest.replaceAll("-", " ").toUpperCase();
                    if (tag != '') {
                        $('#dropdwon-size').css('display', 'block');
                        $('.size-select').css('display', 'block');
                        $(".box-desc").removeClass("is-sticky-remove");
                        let tagmodal = tag;
                        let testtag = tag.replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                        let replaceTag = tagmodal.replaceAll("-", " ");
                        dropdown2.append($("<option></option>")
                        .attr("value", testtag).text(con));
                    } else {
                        $('#dropdwon-size').css('display', 'none');
                        $('.size-select').css('display', 'none');
                        $(".box-desc").addClass("is-sticky-remove");
                     }
                });
                // console.log("This is tag " + sizetags);
                if(sizetagsText != '' || tags != ''){
                    // console.log('size tag is not null');
                    $('.product-list').addClass('d-none');
                    $('.colection-choose-tag').show();
                    $(".collection__step").show();
                    $(".tab-pane.step-2").removeClass("no-size-model-select");
                    $('[data-click=2]').css('pointer-events', 'painted');
                }else{
                    // console.log('size tag is null');
                    $('.product-list .row').html('');
                    let collectionHandle = $('input[name=radio]:checked').attr('data-collection-handle');
                    $.ajax({
                        url: '/collections/' + collectionHandle + '?view=ajax',
                        method: "GET",
                        dataType: "HTML",
                        success: function(htmlData) {
                            let html_markup = $(htmlData);
                            // let to_replace = $(htmlData).find('.product-list .row').html();
                            let to_replace = $(htmlData).find('.js_bg_product').html();
                            // console.log(to_replace);
                            $('#custom-preloader').css('display', 'none');
                            $('body').removeClass('overlay-cus');
                            $('[data-click=3]').addClass('active');
                            $(".progress-bar").css("width",  "calc(100% - 100px)");
                            $('[data-click=2]').css('pointer-events', 'none');
                            $(".collection__step ul li:nth-child(2)").addClass("process-done");
                            $('.product-list').removeClass('d-none');
                            $('.colection-choose-tag').hide();
                            // $(".collection__step ul li").removeClass('process-done');
                            // $('#collection_step_2').css('pointer-events', 'none');
                            //$(".collection__step").hide();
                            $(".tab-pane.step-2").addClass("no-size-model-select");
                            $('.product-list .row').html(to_replace);
                            $(".product-list__col").slice(0, 6).show();
                            // $(".product-list .js-load-more-btn").show();
                            $('.product-list__desc h5').matchHeight({
                                byRow: 0,
                            });
                            // if ($(".product-list__col:hidden").length == 0) {
                            //     $(".product-list .js-load-more-btn").hide();
                            // }
                        },
                        error: function(data) {
                            window.alert(data.responseJSON.description);
                        }
                    });
                }
            }
            populateDropdownWithModalTags();
           
                        

          });
     
    
});


